import { MapToContext } from '@utils/objectWithDefault'
import _sumBy from 'lodash/sumBy'

export default class OnHoldNotifications {
  constructor (onHoldNotifications) {
    const defaultOnHoldNotifications = {
      notifications: { val: [], type: Array, subType: OnHoldNotification }
    }
    MapToContext(this, defaultOnHoldNotifications, onHoldNotifications)
  }

  get totalOrderrsAffected () {
    return _sumBy(this.notifications, o => o.totalOrdersAffected)
  }
}

export class OnHoldNotification {
  constructor (onHoldNotification) {
    const defaultOnHoldNotification = {
      id: { val: 0, type: Number },
      name: { val: '', type: String },
      totalOrdersAffected: { val: 0, type: Number },
      details: { val: [], type: Array, subType: OnHoldNotificationDetails }
    }
    MapToContext(this, defaultOnHoldNotification, onHoldNotification)
  }
}

export class OnHoldNotificationDetails {
  constructor (onHoldNotification) {
    const defaultOnHoldNotification = {
      id: { val: 0, type: Number },
      reference: { val: '', type: String },
      totalOrdersAffected: { val: 0, type: Number },
      ordersAffected: { val: [], type: Array, subType: Number }
    }
    MapToContext(this, defaultOnHoldNotification, onHoldNotification)
  }
}
